import { UserClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiUserClient = new UserClient(defaultAxiosInstance)
